// extracted by mini-css-extract-plugin
var _1 = "KaRTpQlQRq98MZsaT4Rh";
var _2 = "QexBiECYgwx6OR0fYR2n";
var _3 = "CH9VPYF82AH7htUrgyZJ";
var _4 = "KaRTpQlQRq98MZsaT4Rh";
var _5 = "QexBiECYgwx6OR0fYR2n";
var _6 = "CH9VPYF82AH7htUrgyZJ";
var _7 = "ettNrPMMhOCpgpnE8prB";
var _8 = "ettNrPMMhOCpgpnE8prB";
var _9 = "LjlDrHySXIhw8ir_OTex";
var _a = "ejvJM1xod0Y9742V9hCz";
var _b = "ejvJM1xod0Y9742V9hCz";
var _c = "uAxkOe05Tr6CBw2n1ymr";
export { _1 as "contact-detail-heading", _2 as "contact-email", _3 as "contact-number", _4 as "contactDetailHeading", _5 as "contactEmail", _6 as "contactNumber", _7 as "form-bottom-margin", _8 as "formBottomMargin", _9 as "minimum", _a as "no-bottom-padding", _b as "noBottomPadding", _c as "title" }
